import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';

export const viewGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const apiService = inject(ApiService);
  const router = inject(Router);

  if (!apiService.isLoggedIn()) {
    // Save the attempted URL so login can redirect back after auth
    const attemptedUrl = state.url;
    if (attemptedUrl && attemptedUrl !== '/' && !attemptedUrl.startsWith('/auth')) {
      localStorage.setItem('redirectAfterLogin', attemptedUrl);
    }

    router.navigate(['auth/login']);
    return false;
  }

  return true;
};
